<template>
  <div>
    <a-popover placement="right" overlay-class-name="audio-popover">
      <template slot="content" style="text-align: center;padding: 4px 4px;">
        <a-button type="link" size="small" @click="audioToWords()">语音转文字</a-button>
      </template>
      <div class="x-audio-wrap" :class="{inline:!block}" :style="{'width':width}" ref="wrap" @click="play">
        <div class="x-sector" :class="{play:animate}" :title="text">
          <div class="x-dot"></div>
        </div>
        <div class="x-time">{{duration&&showDuration?duration:text}}</div>
      </div>
    </a-popover>
    <p style="margin-top: 3px;" v-if="words">{{words}}</p>
  </div>
</template>

<script>
export default {
  name: "Audio",
  props:{
    src:{
      type:String,
      default:''
    },
    text:{
      type:String,
      default:"轻触播放"
    },
    showDuration:{
      type:Boolean,
      default:true
    },
    block:{
      type:Boolean,
      default:false
    },
  },
  data(){
    return{
      audio:null,
      animate:false,
      timer:null,
      duration:null,
      width:'115px',
      words:''
    }
  },
  mounted(){
    const self = this;
    this.audio=new Audio();
    this.audio.src=this.src;
    this.audio.addEventListener('canplaythrough',()=>{
      self.width = (this.audio.duration.toFixed(0)*6)+'px';
      this.duration=this.format(this.audio.duration);
    })
    this.audio.onplay=()=>{
      this.animate=true;
      this.timer=setInterval(() => {
        this.animate=false;
        setTimeout(()=>{
          this.animate=true;
        },50);
      }, 1250);
    }
    this.audio.onpause=()=>{
      this.animate=false
      this.timer&&clearInterval( this.timer)
    }
    this.audio.onended=()=>{
      this.animate=false
      this.timer&&clearInterval( this.timer)
    }
  },
  methods:{
    play(){
      if(this.audio.paused){
        this.audio.play()
      }else{
        this.audio.pause()
      }
    },
    audioToWords:function(){
      const self = this;
      this.words='正在进行语音转文字....';
      this.$axios.get('/api/dmz/asr', {params:{url:this.src}}).then(function(res){
        if(res.msg.flag == 0){
          if(null == res.biz){
            self.words='语音转文字出错,请重新操作.';
          }else{
            self.words = res.biz;
          }
        }else{
          self.words='语音转文字出错,请重新操作.';
        }
      },function(res){
        self.words='语音转文字出错,请重新操作.';
      });
    },
    format(s){
      var t='';
      if(s > -1){
        var min = Math.floor(s/60) % 60;
        var sec = s % 60;
        if(min < 10){t += "0";}
        t += min + "'";
        if(sec < 10){t += "0";}
        t += sec.toFixed(2);
      }
      t=t.replace('.','\"')
      return t;
    },
  }
}
</script>
<style scoped>
  .audio-popover{
    width: 80px;
  }
  .audio-popover .ant-popover-inner-content {
    padding: 4px 4px;
    color: rgba(0,0,0,.65);
  }
  .x-audio-wrap{
    margin-top: 7px;
    height: 32px;
    min-width: 60px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    box-shadow: 0px 0px 5px rgba(24, 144, 255, 1);
  }

  .x-audio-wrap .x-sector{
    height: 7px;
    width: 7px;
    border-radius:4px 10px;
    border-right: 2px solid #ddd;
    border-top: 2px solid #ddd;
    transform: rotate(45deg);
    position: relative;
    margin-left: 10px;
  }
  .x-audio-wrap .x-sector::before{
    content: "";
    height: 9px;
    width: 9px;
    border-radius:4px 12px;
    border-right: 2px solid #ddd;
    border-top: 2px solid #ddd;
    transform: rotate(0deg);
    position: absolute;
    right: -7px;
    top: -7px;
  }
  .x-audio-wrap .x-sector .x-dot{
    height: 4px;
    width: 4px;
    border-radius: 4px;
    background: #ddd;
    position: absolute;
    top: 4px;
  }
  .x-audio-wrap .x-sector::after{
    content: "";
    height: 12px;
    width: 12px;
    border-radius:4px 14px;
    border-right: 2px solid #ddd;
    border-top: 2px solid #ddd;
    transform: rotate(0deg);
    position: absolute;
    right: -13px;
    top: -13px;
  }
  .x-audio-wrap .x-time{
    color: #999;
    font-size: 12px;
    margin-right: 10px;
  }
  .x-audio-wrap .inline{
     display: inline-flex
   }
  @keyframes play-dot{
    from{
      background: #ddd
    }
    to{
      background: #5cadff
    }
  }
  @keyframes play-sector{
    from{
      border-color: #ddd
    }
    to{
      border-color: #5cadff
    }
  }
  .x-sector.play{
    animation: play-sector 0.3s 0.1s ease-in-out;
  }
  .x-sector.play::before{
    animation: play-sector 0.3s 0.2s ease-in-out;
  }
  .x-sector.play::after{
    animation: play-sector 0.3s 0.3s ease-in-out;
  }
  .x-sector.play .x-dot{
    animation: play-dot 0.3s ease-in-out;
  }
</style>
